import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { Promotion } from '../../@types/prefix'
import { Button, Checkbox, Flex, Form, Input, Select, Space } from 'antd'
// import { RedoOutlined } from '@ant-design/icons';
// import { getDomainWithoutSubdomain } from '../../utils/domainWithoutSubdomain'
import { useLocation } from 'react-router-dom';
import Turnstile from "react-turnstile";
import PatternNumber from '../../helpers/PatternNumber';

const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
interface RegisterStep3Props {
	knowFrom: string
	prefixInfo: any
	defaultAffiliateCode: string
	promotions: Promotion[]
	isSubmitting: boolean
	recaptcha: any
	resetCounter: number

	setKnowFrom: (e: any) => void
	handleSubmit: (step: number, isRequestOTP: boolean) => void
	setTurnstile: (e: any) => void
	termandcondition: string
	termandconditionModal: (e: ChangeEvent<any>) => void
	setCheckTermandcondition: (e: any) => void
}

const RegisterStep3: FC<RegisterStep3Props> = ({
	knowFrom,
	prefixInfo,
	defaultAffiliateCode,
	promotions,
	isSubmitting,
	recaptcha,
	resetCounter,

	setKnowFrom,
	handleSubmit,
	setTurnstile,
	termandcondition,
	termandconditionModal,
	setCheckTermandcondition,
}) => {
	const affiliateReadOnly = defaultAffiliateCode ? true : false

	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const getParamsRec = params.get('rec');
	const [submitActive, setSubmitActive] = useState<string>('')


	const preventScroll = (e: TouchEvent) => {
		e.preventDefault();
	};

	const handleDropdownVisibleChange = (open: boolean) => {
		if (isMobileDevice) {
			if (open) {
				document.addEventListener('touchmove', preventScroll, { passive: false });
			} else {
				document.removeEventListener('touchmove', preventScroll);
			}
		}
	};

	return (
		<>
			<Form.Item
				name="password"
				rules={[
					{ required: true, message: 'กรุณากรอกรหัสผ่าน' },
					{ pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }
				]}
				style={{ marginBottom: 12 }}
				hasFeedback>
				<Input.Password placeholder="รหัสผ่าน (ตัวเลข 6 หลัก)" inputMode='numeric' maxLength={6} minLength={6} showCount />
			</Form.Item>
			{!defaultAffiliateCode && (
				<Form.Item
					name="knowFrom"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					initialValue={getParamsRec}
					style={{ marginBottom: 12, display: getParamsRec ? 'none' : undefined }}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						// showSearch
						disabled={getParamsRec ? true : false}
						optionFilterProp="children"
						onSelect={setKnowFrom}
						onDropdownVisibleChange={handleDropdownVisibleChange}
					// filterOption={(input: any, option: any) =>
					// 	option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					// }
					>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">X (Twitter)</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="sms" key="sms">SMS</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="friend" key="friend">เพื่อนแนะนำ</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}
			{defaultAffiliateCode && (
				<Form.Item
					name="knowFrom2"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					initialValue={getParamsRec}
					style={{ marginBottom: 12, display: getParamsRec ? 'none' : undefined }}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						// showSearch
						disabled={getParamsRec ? true : false}
						optionFilterProp="children"
						onDropdownVisibleChange={handleDropdownVisibleChange}
					// filterOption={(input: any, option: any) =>
					// 	option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					// }
					>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">X (Twitter)</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="sms" key="sms">SMS</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}

			{knowFrom === "friend" && (
				<Form.Item
					name="affiliateCode"
					rules={[{ required: true, message: 'กรุณากรอกรหัสชวนเพื่อน' }]}
					style={{ marginBottom: 12 }}
					hasFeedback
					initialValue={defaultAffiliateCode}>
					<Input placeholder="รหัสชวนเพื่อน" inputMode='text' readOnly={affiliateReadOnly} />
				</Form.Item>
			)}

			{recaptcha.enable && (
				<div style={{ marginBottom: "10px" }}>
					<Turnstile
						key={resetCounter}
						sitekey={recaptcha.key}
						theme="dark"
						onVerify={(token) => {
							setTurnstile(token)
							setSubmitActive(token)
						}}
						retry='auto'
						autoResetOnExpire={true}
					/>
				</div>
			)}

			{termandcondition && (
				<div className="termandcondition-form-item">
					<Checkbox onChange={setCheckTermandcondition}>
						ยอมรับ
					</Checkbox>
					<span className="termandcondition" onClick={termandconditionModal}>เงื่อนไขและกติกา</span>
				</div>
			)}

			<Form.Item style={{ marginBottom: 16 }}>
				<Button
					type="primary"
					htmlType="submit"
					loading={isSubmitting}
					disabled={submitActive ? false : true}
					onClick={() => { handleSubmit(prefixInfo.recaptcha.enable && prefixInfo?.functions.otp_register ? 2 : 1, false) }}
					block
				>
					สมัครสมาชิก
				</Button>
			</Form.Item>

		</>
	)
}

export default RegisterStep3
